import { Link } from "react-router-dom";
import { Heart, LockSimple } from "@phosphor-icons/react";

// Built-in Favourites book on the dashboard — always present, can't be renamed or deleted.
export const FavouritesBookCard = ({ count = 0 }) => (
  <Link to="/favourites" data-testid="cb-card-favourites" className="group block">
    <div className="aspect-[4/5] rounded-2xl bg-gradient-to-br from-rose-500 to-rose-800 shadow-lg group-hover:shadow-2xl group-hover:-translate-y-0.5 transition-[box-shadow,transform] duration-200 flex flex-col items-center justify-center text-white p-6 text-center">
      <Heart size={56} weight="fill" className="mb-3" />
      <p className="font-display text-3xl font-black">Favourites</p>
      <p className="text-sm text-white/80 mt-1">Recipes you&apos;ve hearted</p>
    </div>
    <div className="mt-3 flex items-center gap-2 flex-wrap">
      <span className="chip !text-[10px] inline-flex items-center gap-1"><LockSimple size={10} weight="bold" /> private</span>
      <span className="chip !text-[10px]" data-testid="cb-card-favourites-count">{count} {count === 1 ? "recipe" : "recipes"}</span>
    </div>
  </Link>
);
